module.exports = __webpack_public_path__ + "img/NO937889275.484c2ff5.svg";